// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_WARRANTY_INFO_DATA = 'GET_WARRANTY_INFO_DATA';
export const GET_WARRANTY_INFO_DATA_SUCCESS = 'GET_WARRANTY_INFO_DATA_SUCCESS';
export const GET_WARRANTY_INFO_DATA_FAIL = 'GET_WARRANTY_INFO_DATA_FAIL';

export const {
    getWarrantyInfoData,
    getWarrantyInfoDataSuccess,
    getWarrantyInfoDataFail,
} = createActions(
    GET_WARRANTY_INFO_DATA,
    GET_WARRANTY_INFO_DATA_SUCCESS,
    GET_WARRANTY_INFO_DATA_FAIL
);